var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{attrs:{"id":_vm.id},domProps:{"value":_vm.oldValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }